import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";

/**
 * SPA에서 라우트가 변경될 때마다 등록된 Analytics 공급자에 개인정보 없는
 * pathname 페이지뷰를 전달하는 공용 컴포넌트입니다.
 */
export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return <Outlet />;
}
